import { SITE } from '../config/site';

/**
 * Per-route document head.
 *
 * React 19 hoists <title>, <meta> and <link rel="canonical"> to <head> from
 * anywhere in the tree, so no helmet dependency is needed. Every route renders
 * this once; previously all nine routes shared a single hardcoded title.
 */
export default function Seo({
  title,
  description = SITE.description,
  path = '/',
  // TODO: replace with a purpose-made 1200×630 card at /og-image.jpg — the
  // logo is square, so social platforms crop it heavily.
  image = `${SITE.url}/logo.png`,
  noindex = false,
  children,
}) {
  const fullTitle = title ? `${title} | ${SITE.name}` : `${SITE.name} — Abonnement IPTV Premium`;
  const canonical = `${SITE.url}${path}`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={SITE.locale} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {children}
    </>
  );
}

/**
 * Renders a JSON-LD block. The payload is built from our own static data, never
 * from user input, so serialising it here is safe.
 */
export function JsonLd({ data }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, '\\u003c') }}
    />
  );
}
